import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPopups, PopupsSymbol } from './index'
import { ILinkClickHandler } from '@wix/thunderbolt-symbols'
import { IUrlHistoryManager, UrlHistoryManagerSymbol } from 'feature-router'

const TOP_AND_BOTTOM_ANCHORS = ['SCROLL_TO_TOP', 'SCROLL_TO_BOTTOM']

const popupLinkFactory = (popupApi: IPopups, urlHistoryManager: IUrlHistoryManager): ILinkClickHandler => ({
	handleClick: (anchor) => {
		const popupId = anchor.getAttribute('data-popupid')
		if (popupId) {
			popupApi.openPopupPage(popupId)
			return true
		}
		const relativeUrl = urlHistoryManager.getRelativeUrl()
		const isLightboxOpen = !!popupApi.getCurrentPopupId()
		const isLinkToCurrentPage = relativeUrl === anchor.getAttribute('href')

		const anchorDataId = anchor.getAttribute('data-anchor') || ''
		const isTopBottomAnchor = TOP_AND_BOTTOM_ANCHORS.includes(anchorDataId)

		if (isLightboxOpen && (isLinkToCurrentPage || isTopBottomAnchor)) {
			popupApi.closePopupPage()
			return true
		}

		return false
	},
})

export const PopupLink = withDependencies([PopupsSymbol, UrlHistoryManagerSymbol], popupLinkFactory)
